import { useCallback, useEffect, useState } from "react";
import {
    hasShownFavoriteGuideTooltip,
    markFavoriteGuideTooltipAsShown,
} from "../libs/favoriteTooltipStorage";

type Params = {
    userId: string;
};

const FAVORITE_TOOLTIP_OPEN_DELAY_MS = 400;

export const useFavoriteGuideTooltip = ({ userId }: Params) => {
    const [isGuideOpen, setIsGuideOpen] = useState<boolean>(false);

    const closeGuide = useCallback(() => {
        setIsGuideOpen(false);
    }, []);

    useEffect(() => {
        if (!userId) return;
        if (hasShownFavoriteGuideTooltip(userId)) return;

        const timeoutId = window.setTimeout(() => {
            setIsGuideOpen(true);
            markFavoriteGuideTooltipAsShown(userId);
        }, FAVORITE_TOOLTIP_OPEN_DELAY_MS);

        return () => {
            window.clearTimeout(timeoutId);
        };
    }, [userId]);

    return {
        isGuideOpen,
        closeGuide,
    };
};
